import { render, staticRenderFns } from "./BaseTLModalDialogTag.vue?vue&type=template&id=6b52bc22&"
import script from "./BaseTLModalDialogTag.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialogTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports